module.exports = __webpack_public_path__ + "static/media/template-list.859713ea.png";